import ActionMenu from "../../../../components/ui/materialui/actionMenu";
import { CoberturaPoliza } from "../models/polizaSeguro";
import EditIcon from "@mui/icons-material/Edit";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { deleteCoberutura } from "../service/servicePoliza";
import { StatusCode } from "../../../../utils/enums";
import { useToast } from "../../../../hooks/useToast";
import { useState } from "react";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";

interface IProps {
    cobertura: CoberturaPoliza;
    setCoberturaEditar?: React.Dispatch<React.SetStateAction<CoberturaPoliza | undefined>>;
    setIsEditarCobertura?: (value: boolean) => void;
    onCreateEditClick?: () => void;
    refresh?: () => void;
}

const AccionesCobranza: React.FC<IProps> = ({ 
    cobertura, 
    setCoberturaEditar, 
    setIsEditarCobertura,
    onCreateEditClick,
    refresh 
}) => {
    const { addToast } = useToast();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);

    const handleEditarClick = () => {
        if (onCreateEditClick) {
            onCreateEditClick();
            
            if (setCoberturaEditar) {
                setCoberturaEditar(cobertura);
            }
            
            if (setIsEditarCobertura) {
                setIsEditarCobertura(true);
            }
        }
    };

    const handleDeleteClick = () => {
        setShowConfirmDelete(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteCoberutura(cobertura.polizaCodigo);
            
            if (response.status === StatusCode.NoContent || response.status === StatusCode.Ok) {
                addToast({
                    mostrar: true,
                    titulo: 'Confirmación',
                    tipo: 'Success',
                    mensaje: 'Cobertura eliminada con éxito.'
                });
                
                if (refresh) {
                    refresh();
                }
            }
        } catch (error) {
          
        }
    };

    const actions = [
        { 
            label: "Editar", 
            icon: <EditIcon fontSize="small" />, 
            onClick: handleEditarClick 
        },
        { 
            label: "Eliminar", 
            icon: <GridDeleteIcon fontSize="small" />, 
            onClick: handleDeleteClick 
        },
    ];

    return (
        <>
            <ActionMenu actions={actions} />
            <ConfirmationModal
                show={showConfirmDelete}
                onHide={() => setShowConfirmDelete(false)}
                onConfirm={confirmDelete}
                title="Confirmar eliminación"
                message={`¿Está seguro que desea eliminar la cobertura ${cobertura.codigoCobertura}?`}
                size="sm"
            />
        </>
    );
};

export default AccionesCobranza;